import { Component } from 'react';
import { getBlockComponent } from './BlockRegistry';
import UnsupportedBlock from './blocks/UnsupportedBlock';
import './blocks';

// One broken block must not take down the whole page (spec section 31).
class BlockBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error(`Content block "${this.props.type}" failed to render`, error);
  }

  render() {
    return this.state.failed ? <UnsupportedBlock block={{ type: this.props.type }} failed /> : this.props.children;
  }
}

/**
 * Renders a canonical content document body. Used by both preview and the public site (spec section 46).
 * headingOffset shifts heading levels so the page title can own <h1>.
 */
export default function ContentRenderer({ blocks, headingOffset = 0 }) {
  if (!Array.isArray(blocks)) return null;
  return (
    <div className="content-body">
      {blocks.map((block, i) => {
        const Block = getBlockComponent(block?.type) || UnsupportedBlock;
        return (
          <BlockBoundary key={i} type={block?.type}>
            <Block block={block} headingOffset={headingOffset} />
          </BlockBoundary>
        );
      })}
    </div>
  );
}
